import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import SubmitButton from "../Buttons/SubmitButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import { db } from "../../firebase";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import moment from "moment";
import "moment/locale/fr";
import html2pdf from "html2pdf.js";
import logo from "../../assets/logo.webp";
import digisign from "../../assets/digisign.png";
// import numToWords from 'num-to-words';

const Step6bis = ({
  firstVehicle,
  vehicles,
  formdocId,
  tarifsBlock,
  signature,
  signatureImage,
  onBack,
}) => {
  const { logout } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const [isLoadingGeneratePdf, setIsLoadingGeneratePdf] = useState(false);

  const navigate = useNavigate();
  moment.locale("fr");

  const writtenNumber = require("written-number");

  const convertAmountToWords = (amount) => {
    writtenNumber.defaults.lang = "fr"; // Utilisation de la langue française
    const integerPart = Math.floor(amount);
    const decimalPart = Math.round((amount - integerPart) * 100);
    const integerPartInWords = writtenNumber(integerPart);
    const decimalPartInWords =
      decimalPart > 0 ? writtenNumber(decimalPart) : null;

    let amountInWords = `${integerPartInWords} dollar${
      integerPart > 1 ? "s" : ""
    }`;
    if (decimalPartInWords) {
      amountInWords += ` et ${decimalPartInWords} centime${
        decimalPart > 1 ? "s" : ""
      }`;
    }
    return amountInWords;
  };

  const generatePDF2 = async (data, vehicles, documentId, tarifsBlock) => {
    setIsLoadingGeneratePdf(true);

    const amountInWords = convertAmountToWords(tarifsBlock.finalPrice);

    const htmlContent = `
    <div style="margin: 60px;">
        <p style="text-align: left;">
            <img width="145" height="84" alt="logo" src="${logo}" />
        </p>
        <br/><br/>
        <h1 style="text-align: center; font-weight: bold; font-size: 24px;">
            Facture N° : ${documentId}<br/><br/>
        </h1>
        
        <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
            <tbody>
                <tr>
                    <td colspan="4" style="border: 1px solid; padding: 3pt; font-weight: bold;">SOUSCRIPTEUR</td>
                </tr>
                <tr>
                    <td colspan="4" style="border: 1px solid; padding: 3pt;">
                        ${
                          data.firstName
                            ? `Nom du client : <b>${data.firstName} ${data.lastName}</b><br/>`
                            : `Raison sociale : <b>${data.raisonSociale}</b><br/>`
                        }
                        Adresse du client : <b>${data.street}, ${data.city}, ${
      data.country
    }</b>
                    </td>
                </tr>
                <tr>
                    <td colspan="4" style="border: 1px solid; padding: 3pt;">
                        Assurance : Assurance Frontière <br/><br/>
                        Police N° : AS-2<br/><br/>
                        <b>Souscription effectuée sur <a href="https://www.digis-assur.cd" target="_blank">https://www.digis-assur.cd</a></b>
                    </td>
                </tr>
                <tr style="background-color: #ECECEC">
                    <td colspan="4" style="border: 1px solid; padding: 3pt; font-weight: bold;">Risque(s) Assuré(s)</td>
                </tr>
                <tr>
                    <td style="border: 1px solid; padding: 6pt;background-color: #f6f6f6"><b>Immatriculation</b></td>
                    <td style="border: 1px solid; padding: 6pt;background-color: #f6f6f6"><b>Date d’effet</b></td>
                    <td style="border: 1px solid; padding: 6pt;background-color: #f6f6f6"><b>Date d’expiration</b></td>
                    <td style="border: 1px solid; padding: 6pt;background-color: #f6f6f6"><b>Prime nette</b></td>
                </tr>
                ${vehicles
                  .map((vehicle) => {
                    const startDate = moment(data.startDate);
                    const duration = vehicle.duration; // 30 ou 90

                    const endDate = startDate.clone().add(duration, "days");

                    console.log(
                      "Date de début :",
                      startDate.format("YYYY-MM-DD")
                    );
                    console.log("Date de fin :", endDate.format("YYYY-MM-DD"));

                    return `
                        <tr>
                            <td style="border: 1px solid; padding: 6pt;">${
                              vehicle.immat
                            }</td>
                            <td style="border: 1px solid; padding: 6pt;">${startDate.format(
                              "DD MMMM YYYY"
                            )}</td>
                            <td style="border: 1px solid; padding: 6pt;">${endDate.format(
                              "DD MMMM YYYY"
                            )}</td>
                            <td style="border: 1px solid; padding: 6pt;">${vehicle.price.toFixed(
                              2
                            )} USD</td>
                        </tr>
                    `;
                  })
                  .join("")}
                <tr>
                    <td colspan="4" style="border: 1px solid; padding: 17pt; text-align: center;">
                        Prime(s) à payer : <b>${tarifsBlock.totalPrice.toFixed(
                          2
                        )} USD</b><br/>
                        TVA (16%) : <b>${tarifsBlock.TVA.toFixed(
                          2
                        )} USD</b><br/>
                        Frais ARCA (2%) : <b>${tarifsBlock.ARCA.toFixed(
                          2
                        )} USD</b><br/>
                        Total à Payer : <b>${tarifsBlock.finalPrice.toFixed(
                          2
                        )} USD</b><br/>
                        En lettres : ${amountInWords}<br/>
                        <p>Ce paiement a été effectué par carte de crédit.</p>
                    </td>
                </tr>
            </tbody>
        </table>
        
        <p style="padding-top: 4pt; text-align: left; font-size: 10px;">
            <b>Fait à Kinshasa, le ${new Date().toLocaleDateString("fr-FR", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}</b>
            <span style="float: right; vertical-align: middle; text-align: left; font-size: 10px;"><b>Pour la Compagnie, Jean-Michel MUKUKU, gérant</b></span>
        </p>

        <p style="padding-top: 4pt; text-align: left; font-size: 10px;">
            <b>Signature client</b>
        </p>
        
        <p style="text-align: right; margin-bottom: 80px">
        <span style="float: left; vertical-align: middle;">
            <img width="145" height="84" alt="logo" src="${signatureImage}" />
        </span>
            
            <span style="float: right; vertical-align: middle;">
            <img width="145" height="84" alt="logo" src="${digisign}" />
        </span>
        </p>

        

        

        <br/><br/><br/>
            <p style="padding-top: 4pt; text-align: left; font-size: 10px;">DIGITAL INNOVATIVE SOLUTIONS SARL, DIGIS SARL en sigle, société à responsabilité limitée. Siège social : 372 avenue Colonel Mondjiba, Commune 
de Ngaliema, Kinshasa (RDC). RCCM : CD/KNG/RCCM/23-B-01880, Id. Nat : 01-H5300-N36881G, NIF : A2317655R, Téléphone : +243 998 530 710, 
adresse électronique : contact@digis-assur.com   </p>
        
    </div>
`;

    // Options de conversion en PDF
    const options = {
      margin: 0,
      filename: `Facture_${documentId}.pdf`,
      image: { type: "jpg", quality: 0.98 },
      html2canvas: { scale: 2 },
      useCORS: true,
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    // Convertir le HTML en PDF
    html2pdf().set(options).from(htmlContent).save();

    const pdfBlob = await html2pdf()
      .set(options)
      .from(htmlContent)
      .toPdf()
      .outputPdf("blob"); // Obtenir le PDF sous forme de Blob

    console.log("PDF généré avec succès.");

    // Enregistrer dans Firebase Storage
    const storage = getStorage();
    const pdfRef = ref(storage, `factures/facture_${documentId}.pdf`);

    const uploadTask = uploadBytesResumable(pdfRef, pdfBlob);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Téléchargement : " + progress + "%");
      },
      (error) => {
        console.error("Erreur lors du téléchargement :", error);
      },
      async () => {
        // Une fois terminé, obtenir l'URL de téléchargement
        const url = await getDownloadURL(uploadTask.snapshot.ref);

        // Mettez à jour le document Firestore
        const formRef = doc(db, "forms", documentId);
        await updateDoc(formRef, {
          facture: url,
        });

        console.log("PDF enregistré et URL mise à jour dans Firestore :", url);
      }
    );
    setIsLoadingGeneratePdf(false);
  };

  const PaymentSuccess = async () => {
    setIsLoading(true);
    const formdocRef = doc(db, "forms", formdocId);
    await updateDoc(formdocRef, {
      paid: true,
    });
    setIsPaid(true);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);

    const script = document.createElement("script");
    script.src = "https://newwebpay.qa.interswitchng.com/inline-checkout.js";
    script.async = true;
    document.body.appendChild(script);
    setIsLoading(false);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (isLoading === false && isPaid === true) {
    }
  }, [isLoading, isPaid]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const initiatePayment = () => {
    const txn_ref = `digis_txn_ref_${Math.floor(100 + Math.random() * 900)}`; // 3 chiffres aléatoires entre 100 et 999

    const paymentRequest = {
      merchant_code: "MX19329",
      pay_item_id: "Default_Payable_MX19329",
      txn_ref: txn_ref,
      site_redirect_url: "https://google.com/",
      amount: 10000,
      currency: 840,
      onComplete: paymentCallback,
      mode: "TEST",
    };

    window.webpayCheckout(paymentRequest);
  };

  const generatePdfAgain = () => {
    setIsLoadingGeneratePdf(true);

    generatePDF2(firstVehicle, vehicles, formdocId, tarifsBlock);
    setIsLoadingGeneratePdf(false);
  };

  const paymentCallback = (response) => {
    setIsLoading(true);

    console.log("Payment Response:", response);
    if (response.resp === "00") {
      // Payment was successful
      //   alert("Paiement accepté ! Merci");
      generatePDF2(firstVehicle, vehicles, formdocId, tarifsBlock);
      // generatePDF(firstVehicle, vehicles, formdocId)
      PaymentSuccess();
    } else {
      // Payment failed
      //   alert("Payment failed: " + response.responseDescription);
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && isLoadingGeneratePdf && (
        <div>
          <p>Chargement...</p>

          {/* <PrimaryButton
            type="button"
            label={"Annuler"}
            onClick={generatePdfAgain}
            disabled={isLoadingGeneratePdf}
          /> */}
        </div>
      )}
      {isLoading === false && isPaid === true && (
        <div>
          <div className="mb-[200px]">
            <p className="text-green-500 text-[20px] ">
              Paiement enregistré avec succès !
            </p>
            <PrimaryButton
              type="button"
              label={"Télécharger à nouveau la facture"}
              onClick={generatePdfAgain}
              disabled={isLoadingGeneratePdf}
            />
          </div>
          <SubmitButton
            type="button"
            label={"Nouveau formulaire"}
            onClick={() => {
              navigate("/board");
            }}
          />
          <PrimaryButton
            type="button"
            label={"Se déconnecter"}
            onClick={handleLogout}
          />
        </div>
      )}
      {isLoading === false && isPaid === false && (
        <>
          <PrimaryButton
            type="button"
            label={"Payer par carte"}
            onClick={initiatePayment}
          />
          <PrimaryButton
            type="button"
            onClick={onBack}
            label={"Retour"}
            className="bg-gray-300 py-2 px-4 rounded mr-2"
          />
        </>
      )}
    </div>
  );
};

export default Step6bis;
